// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Cw6","tabsBox":"styles_tabsBox__1j0_H","createButton":"styles_createButton__2BZ21"};